import { render } from "./MMNavbar.vue?vue&type=template&id=0f87b418"
import script from "./MMNavbar.vue?vue&type=script&lang=js"
export * from "./MMNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__